// // helpers/AuthStatus.js
// export function isRestroUserAuthenticated() {
//   const KEY = 'userDetails';

//   try {
//     const raw = localStorage.getItem(KEY);
//     console.log('🔐 Auth check - Raw data:', raw); // Debug log
    
//     if (!raw) {
//       console.log('❌ No user data found');
//       return false;
//     }

//     const user = JSON.parse(raw);
//     console.log('🔐 Auth check - Parsed user:', user); // Debug log
    
//     if (!user?.token) {
//       console.log('❌ No token found');
//       return false;
//     }

//     console.log('✅ User authenticated with token');
//     return true;
//   } catch (error) {
//     console.error('❌ Auth check failed:', error);
//     return false;
//   }
// }

// export function isSuperAdminAuthenticated() {
//   try {
//     const user = JSON.parse(localStorage.getItem('userDetails') || '{}');
//     return !!(user?.token && user.role === 'superadmin');
//   } catch (error) {
//     console.error('Superadmin check failed:', error);
//     return false;
//   }
// }

// helpers/AuthStatus.js
// helpers/AuthStatus.js
import { getUserDetailsInLocalStorage, clearUserDetailsInLocalStorage, isTokenLikelyExpired } from './UserDetails';

export function isRestroUserAuthenticated() {
  try {
    const user = getUserDetailsInLocalStorage();
    
    if (!user) {
      console.log('Auth: No user data');
      return false;
    }

    if (!user.token) {
      console.log('Auth: No token');
      clearUserDetailsInLocalStorage();
      return false;
    }

    // FIX: Use isTokenLikelyExpired() instead of expiresAt
    if (isTokenLikelyExpired()) {
      console.log('Auth: Token likely expired');
      clearUserDetailsInLocalStorage();
      return false;
    }

    console.log('Auth: Valid token');
    return true;
    
  } catch (error) {
    console.error('Auth: Check failed', error);
    clearUserDetailsInLocalStorage();
    return false;
  }
}

export function isSuperAdminAuthenticated() {
  try {
    const user = getUserDetailsInLocalStorage();
    const isSuperAdmin = !!(user?.token && user.role === 'superadmin' && !isTokenLikelyExpired());
    console.log('SuperAdmin Auth:', isSuperAdmin ? 'Valid' : 'Invalid');
    return isSuperAdmin;
  } catch (error) {
    console.error('SuperAdmin Auth: Failed', error);
    return false;
  }
}

export function getDetailedAuthStatus() {
  try {
    const user = getUserDetailsInLocalStorage();
    
    if (!user) {
      return { isAuthenticated: false, reason: 'no_user_data' };
    }

    if (!user.token) {
      return { isAuthenticated: false, reason: 'no_token' };
    }

    if (isTokenLikelyExpired()) {
      return { isAuthenticated: false, reason: 'token_expired' };
    }

    return { 
      isAuthenticated: true, 
      role: user.role,
      hasToken: true,
      name: user.name || user.username
    };
    
  } catch (error) {
    return { isAuthenticated: false, reason: 'error', error: error.message };
  }
}